import { useMutation } from '@tanstack/react-query';

import { SHARE_TOKEN_PARAM, SHARED_DASHBOARD_PATH } from '@/features/dashboard/constants/const';
import { http } from '@/services/http';

import { dashboardOptions } from '../dashboard.options';

export const useGenerateShareLink = (dashboardName: string) => {
  return useMutation({
    mutationKey: dashboardOptions.mutations.generateShareLink(dashboardName),

    mutationFn: async () => {
      const { data } = await http.go.get<{ shareToken: string }>('/share', {
        params: { dashboardName }
      });
      return `${window.location.origin}${SHARED_DASHBOARD_PATH}?${SHARE_TOKEN_PARAM}=${encodeURIComponent(data.shareToken)}`;
    }
  });
};
